import { WalletList } from '@basqet-dashboard/common/components/';
import { useFetchPayoutWallets } from '@hooks/queries';
import React from 'react';

const PayoutWalletList = () => {
  const { walletsToDisplay, isLoading } = useFetchPayoutWallets();
  return <WalletList wallets={walletsToDisplay} isLoading={isLoading} baseUrl="/payouts" />;
};

export { PayoutWalletList };
